<div class="pos-f-t fixed-top header">
	<nav class="navbar navbar-inverse bg-inverse navbar-toggleable-md">
		<img class="d-flex align-self-center mr-3" src="\assets\images\EntredaLogo.png" alt="Generic placeholder image"
			height="37px" />
	</nav>
</div>
<section class="main-container">
	<div class="card w-50">
		<div class="card-header card-danger text-center">
			<h4 class="card-title">Error</h4>
		</div>
		<div class="card-block" style="min-height: 150px">
			<p class="card-text">{{message}}</p>
		</div>
	</div>
</section>